import Api from '@/services/api';
import {createFormDataFile, removeEmptyParams} from '@utils';

const dateFormat = /[+-]?\d{4}(-[01]\d(-[0-3]\d(T[0-2]\d:[0-5]\d:?([0-5]\d(\.\d+)?)?[+-][0-2]\d:[0-5]\dZ?)?)?)?/;

export default {
  onboarding(onboardingId) {
    return Api()
      .get('/v3/onboarding/' + onboardingId)
      .then((res) => this.formatResDto(res.data));
  },
  save(onboardingId, onboarding) {
    return Api()
      .put('/v3/onboarding/' + onboardingId, onboarding)
      .then((res) => this.formatResDto(res.data));
  },
  dashboard(filter) {
    return Api()
      .get('/v3/onboardings/dashboard', {params: removeEmptyParams(filter)})
      .then((res) => res.data);
  },
  validate(onboardingId, onboarding) {
    return Api()
      .put('/v3/onboarding/' + onboardingId + '/validate', onboarding)
      .then((res) => this.formatResDto(res.data));
  },
  create(onboarding) {
    return Api()
      .post('/v3/onboarding', onboarding)
      .then((res) => this.formatResDto(res.data));
  },
  createFromEstimation(onboarding, estimationId) {
    return Api()
      .post(`/v3/onboarding/estimation/${estimationId}`, onboarding)
      .then((res) => this.formatResDto(res.data));
  },
  createFicForOnboarding(onboardingId, obj, file) {
    let data = createFormDataFile(obj, file);
    return Api()
      .post(`/v3/onboarding/${onboardingId}/fic`, data)
      .then((res) => res.data);
  },
  formatResDto(e) {
    for (let key in e) {
      if (e.hasOwnProperty(key)) {
        for (let subKey in e[key]) {
          if (e[key].hasOwnProperty(subKey)) {
            if (e[key][subKey].type === 'DATE') {
              if (dateFormat.test(e[key][subKey].value)) e[key][subKey].value = new Date(e[key][subKey].value);
            } else if (e[key][subKey].type === 'PERIOD') {
              let tab = [];
              if (e[key][subKey].value) {
                for (let d of e[key][subKey].value) {
                  if (dateFormat.test(d)) {
                    const potentialDate = new Date(d);
                    tab.push(potentialDate);
                  }
                }
              }
              e[key][subKey].value = tab;
            }
          }
        }
      }
    }
    return e;
  },
};
